export const LegalThunks = {};
